import { PlainDate } from "@/temporal"
import type { InputHTMLAttributes } from "vue"
import { inferProps } from "vue-utils"

type Props = {
	value: PlainDate | null
	min?: PlainDate | null
	max?: PlainDate | null
} & (
	| {
			setValue(value: PlainDate): void
			required: true
	  }
	| {
			setValue(value: PlainDate | null): void
			required?: false
	  }
)

function DateInput(
	props: Props & Omit<InputHTMLAttributes, keyof Props>,
	{ attrs }: { attrs: Omit<InputHTMLAttributes, keyof Props> }
) {
	function handleOnInput(event: Event) {
		const value = (event.target as HTMLInputElement).value
		if (value === "" && !props.required) {
			props.setValue(null)
		} else if (value !== "") {
			let date
			try {
				date = PlainDate.from(value)
			} catch {
				return
			}
			props.setValue(date)
		}
	}

	return (
		<input
			type="date"
			value={props.value?.toJSON()}
			onChange={handleOnInput}
			required={props.required}
			min={props.min?.toJSON()}
			max={props.max?.toJSON()}
			{...attrs}
		/>
	)
}

DateInput.props = inferProps<Props>()

export default DateInput
